import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { IFechRequest } from 'interfaces/fetch-duck';
import { requestErrorHandler } from 'utils';
import { FetchUserAlertActions } from 'store/ducks/settings/user-alerts';

export function* fetchUserAlertRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(apiGeneral.get, `/user-alerts/${id}`);

    yield put(FetchUserAlertActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(FetchUserAlertActions.failure(errorMessage));
  }
}
